import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetDashboardRequest } from './get-dashboard-request';
import type { IGetDashboardResponse } from './get-dashboard-response';
import { getDashboardResponseSchema } from './get-dashboard-response';

export async function getDashboardApi(
  params?: IGetDashboardRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetDashboardResponse>> {
  return getRequest<IGetDashboardResponse>({
    path: '/progress/dashboard',
    schema: getDashboardResponseSchema,
    options: {
      ...options,
      params: { ...options?.params, timezone: params?.timezone },
    },
  });
}
